(() => {
  if (!customElements.get('bw-cart-progress')) {
    const lastProgress = new Map();
    customElements.define('bw-cart-progress', class extends HTMLElement {
      connectedCallback() {
        const context = this.closest('cart-drawer') ? 'drawer' : 'page';
        const target = Number(this.dataset.progress);
        const previous = lastProgress.get(context);
        const bar = this.querySelector('.bw-offer__track span');
        lastProgress.set(context, target);
        if (bar && previous !== undefined && previous !== target && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          bar.style.transition = 'none';
          bar.style.width = previous + '%';
          requestAnimationFrame(() => requestAnimationFrame(() => {
            if (!bar.isConnected) return;
            bar.style.transition = '';
            bar.style.width = target + '%';
          }));
        }
      }
    });
  }
  if (!customElements.get('bw-cart-suggestion')) {
    customElements.define('bw-cart-suggestion', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const form = this.querySelector('form');
        const select = form.querySelector('select');
        const button = form.querySelector('button');
        select.addEventListener('change', () => {
          button.disabled = !select.value;
          this.querySelector('[data-bw-price]').textContent = select.selectedOptions[0].dataset.price;
        });
        form.addEventListener('submit', async event => {
          event.preventDefault();
          if (!select.value || button.disabled) return;
          const error = this.querySelector('[data-bw-error]');
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          error.hidden = true;
          const drawer = document.querySelector('cart-drawer');
          const sections = drawer?.getSectionsToRender?.().map(section => section.id) || ['cart-drawer', 'cart-icon-bubble'];
          try {
            const response = await fetch(form.action.replace(/\.js$/, '') + '.js', {
              method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
              body: JSON.stringify({items: [{id: select.value, quantity: 1}], sections, sections_url: location.pathname})
            });
            const result = await response.json();
            if (!response.ok || result.status) throw new Error(result.description || 'Cart error');
            if (drawer?.renderContents && result.sections?.['cart-drawer']) {
              drawer.renderContents(result);
            } else {
              location.assign((window.Shopify?.routes?.root || '/') + 'cart');
            }
          } catch (failure) {
            error.hidden = false;
            button.disabled = false;
          } finally {
            button.removeAttribute('aria-busy');
          }
        });
      }
    });
  }
})();
